import { useMutation } from '@tanstack/react-query';

import { createRequestPaymentInput } from '../services';

export function useCreateRequestPaymentInput() {
  return useMutation({
    mutationFn: createRequestPaymentInput,
  });
}
